import { Routes } from '@angular/router';
import { ROUTES } from './models/enums/Routes.enum';
import { appLang } from '../environments/app-lang';
import { LandingPageViewComponent } from './views/landing-page-view/landing-page-view.component';

export const getRoutes = (): Routes => {
  const lang = appLang.language as keyof typeof ROUTES;

  return [
    { path: '', component: LandingPageViewComponent, pathMatch: 'full' },

    {
      path: ROUTES[lang].LOGIN.value,
      loadComponent: () =>
        import('./views/login-view/login-view.component').then(
          (m) => m.LoginViewComponent
        ),
    },
    {
      path: ROUTES[lang].PLAN_MEETING.value,
      loadComponent: () =>
        import('./views/plan-meeting-view/plan-meeting-view.component').then(
          (m) => m.PlanMeetingViewComponent
        ),
    },
    {
      path: ROUTES[lang].ABOUT_SCHEDULED_MEETING.value,
      loadComponent: () =>
        import(
          './views/about-scheduled-meeting/about-scheduled-meeting.component'
        ).then((m) => m.AboutScheduledMeetingComponent),
    },
    {
      path: ROUTES[lang].EDIT_SCHEDULED_MEETING.value,
      loadComponent: () =>
        import(
          './views/edit-scheduled-meeting/edit-scheduled-meeting.component'
        ).then((m) => m.EditScheduledMeetingComponent),
    },
    {
      path: ROUTES[lang].PAYMENT_SUMMARY.value,
      loadComponent: () =>
        import('./views/payment-summary/payment-summary.component').then(
          (m) => m.PaymentSummaryComponent
        ),
    },

    // --- Nowa wizyta (zagnieżdżone trasy) ---
    {
      path: ROUTES[lang].NEW_VISIT.path,
      loadComponent: () =>
        import(
          './views/schedule-visit-view/schedule-visit-view.component'
        ).then((m) => m.ScheduleVisitViewComponent),
      children: [
        {
          path: ROUTES[lang].NEW_VISIT.TYPE.path,
          loadComponent: () =>
            import(
              './views/schedule-visit-view/step1-view/step1-view.component'
            ).then((m) => m.Step1ViewComponent),
        },
        {
          path: ROUTES[lang].NEW_VISIT.TERM.path,
          loadComponent: () =>
            import(
              './views/schedule-visit-view/step2-view/step2-view.component'
            ).then((m) => m.Step2ViewComponent),
        },
        {
          path: ROUTES[lang].NEW_VISIT.SPECIALIST.path,
          loadComponent: () =>
            import(
              './views/schedule-visit-view/step3-view/step3-view.component'
            ).then((m) => m.Step3ViewComponent),
        },
        {
          path: ROUTES[lang].NEW_VISIT.PATIENT_DATA.path,
          loadComponent: () =>
            import(
              './views/schedule-visit-view/step4-view/step4-view.component'
            ).then((m) => m.Step4ViewComponent),
          pathMatch: 'full',
        },
        {
          path: ROUTES[lang].NEW_VISIT.SUMMARY.path,
          loadComponent: () =>
            import(
              './views/schedule-visit-view/step5-view/step5-view.component'
            ).then((m) => m.Step5ViewComponent),
        },
        { path: '*', redirectTo: ROUTES[lang].NEW_VISIT.TYPE.path },
        { path: '**', redirectTo: ROUTES[lang].NEW_VISIT.TYPE.path },
      ],
    },
    {
      path: ROUTES[lang].ARTICLE.path,
      loadComponent: () =>
        import('./views/blog-article-view/blog-article-view.component').then(
          (m) => m.BlogArticleViewComponent
        ),
    },
    {
      path: ROUTES[lang].BLOG.value,
      loadComponent: () =>
        import('./views/blog-list-view/blog-list-view.component').then(
          (m) => m.BlogListViewComponent
        ),
    },
    {
      path: ROUTES[lang].CONTACT.value,
      loadComponent: () =>
        import('./views/contact-view/contact-view.component').then(
          (m) => m.ContactViewComponent
        ),
    },
    {
      path: ROUTES[lang].SPECIALISTS.value,
      loadComponent: () =>
        import(
          './views/specialists-list-view/specialists-list-view.component'
        ).then((m) => m.SpecialistsListViewComponent),
    },
    {
      path: ROUTES[lang].SPECIALIST.path,
      loadComponent: () =>
        import(
          './views/specialist-profile-view/specialist-profile-view.component'
        ).then((m) => m.SpecialistProfileViewComponent),
    },
    {
      path: ROUTES[lang].ERROR.value,
      loadComponent: () =>
        import('./views/error-view/error-view.component').then(
          (m) => m.ErrorViewComponent
        ),
    },

    { path: '*', redirectTo: '' },
    { path: '**', redirectTo: '' },
  ];
};
